export const RELEASE: string = "0.8.2"
export const VERSION: number = 17;